const megamenus = document.querySelectorAll(".megamenu-js");
let mouseMoved = false;



megamenus.forEach((element) => {
  element.addEventListener("mouseenter", (e) => {
    const megamenu = getMegamenu(element);
    if (megamenu && mouseMoved) {
      megamenu.classList.remove("hide");
      megamenu.classList.remove("we-megamenu-fadeout");
      megamenu.classList.add("we-megamenu-fadein");
      document.addEventListener("scroll", closeMegamenu);
    }
  });

  element.addEventListener("mouseleave", (e) => {
    const megamenu = getMegamenu(element);
    if (megamenu) {
      megamenu.classList.remove("we-megamenu-fadein");
      megamenu.classList.add("we-megamenu-fadeout");
      document.removeEventListener("scroll", closeMegamenu);
    }
  });
});


function closeMegamenu() {
  megamenus.forEach((element) => {
    const megamenu = getMegamenu(element);
    if (megamenu) {
      megamenu.classList.remove("we-megamenu-fadein");
      megamenu.classList.add("we-megamenu-fadeout");
      document.removeEventListener("scroll", closeMegamenu);
    }
  });
}

function getMegamenu(element) {
  let megamenu = element.querySelector(".wesite_megamenu");
  return megamenu;
}

function onMouseMove() {
  mouseMoved = true;
  document.removeEventListener('mousemove', onMouseMove);
}

window.addEventListener('load', () => {
  document.addEventListener('mousemove', onMouseMove);
});